module.exports = __webpack_public_path__ + "static/media/naive.59e79a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/types/naive.png
// module id = 75
// module chunks = 0